$(document).ready(function () {
    $(".icon-read-more").click(function () {
        $(".additioal_block_box").slideDown(); // Show all
        $(".icon-read-more").hide();
        $(".icon-read-less").show();
    });

    $(".icon-read-less").click(function () {
        $(".additioal_block_box").slice(4).slideUp(); // Hide after first 4
        $(".icon-read-less").hide();
        $(".icon-read-more").show();
    });
     document.querySelectorAll(".read-less-btn").forEach(btn => {
    btn.textContent = btn.textContent.replace("⬆️", "").trim();
  });
   document.querySelectorAll(".read-more-btn").forEach(btn => {
    btn.textContent = btn.textContent.replace("⬇️", "").trim();
  });
});